import React from 'react';
import { Separator } from '../../../../../CommonComponents/OPL/Separator/Separator';
import { Alert } from '../../../../../CommonComponents/OPL/Alert/Alert';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Link } from '../../../../../CommonComponents/OPL/Link/Link';

export const Header = () => {
  return (
    <>
      <Alert variant="info">
        <Box>
          For more help please see our{' '}
          <Link
            href="https://orionadvisorservices.my.site.com/OrionSupportApp/s/article/Orion-Planning-Integrations"
            target="_blank"
            rel="noreferrer noopener"
          >
            Third Party Integration Resource Center Page
          </Link>
          . Refresh your browser after 5 minutes of connecting your account. If you do not see your
          clients, contact{' '}
          <Link href="mailto:financialplanning@orion.com">financialplanning@orion.com</Link>.
        </Box>
      </Alert>
    </>
  );
};
